import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Card } from "antd";
import { hasPrivilege } from "../api/token";
import OtaExplorer from "../components/OtaExplorer";
import { withLocale } from './../l10n';

function OtaFirmware() {
  const navigate = useNavigate();
  const ota_view = hasPrivilege('ota_view');

  useEffect(() => {
    if (!ota_view) {
      navigate("/");
    }
  }, [navigate, ota_view])

  if (ota_view) {
    // Sin cabecera: el alto de la tarjeta es fijo y el contenido se desplaza dentro
    return (
      <Card className="ota-card">
        <OtaExplorer />
      </Card>
    );
  }
}

export default withLocale(OtaFirmware);
